(function () {
    'use strict';

    run.parts.dataTables = function() {
        $(document).ready(function() {
            $('.datatables').DataTable({
                responsive: true,
                language: {
                    searchPlaceholder: translations.search,
                    sSearch: '',
                    paginate: {
                        next: '<i class="fa fa-chevron-circle-right" aria-hidden="true"></i>',
                        previous: '<i class="fa fa-chevron-circle-left" aria-hidden="true"></i>',
                    }
                },
                paging: false,
                searching: false,
                bInfo: false,
            });
        });
    };
})();